// adapted from: https://raw.githubusercontent.com/HubSpot/react-select-plus/master/src/OptionGroup.js
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var OPTION_LABEL_STYLING = {
  cursor: 'pointer',
  color: '#C2C2C2',
  backgroundColor: '#FFFFFF',
  fontWeight: 'bold'
};
var OptionGroup = function OptionGroup(_ref) {
  var className = _ref.className,
    option = _ref.option,
    label = _ref.label,
    children = _ref.children;
  var classes = classNames(className, option.className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    style: option.style,
    title: option.title
  }, /*#__PURE__*/React.createElement("div", {
    className: "Select-option-group-label",
    style: OPTION_LABEL_STYLING
  }, label), children);
};
OptionGroup.propTypes = {
  children: PropTypes.any,
  // eslint-disable-line @typescript-eslint/no-explicit-any
  className: PropTypes.string,
  // className (based on mouse position)
  label: PropTypes.node,
  // the heading to show above the child options
  option: PropTypes.object.isRequired // object that is base for that option group
};
export default OptionGroup;